import React from 'react';
import { Label } from './ui/label';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { FileText, Receipt, Sparkles } from 'lucide-react';

const DocumentTypeSelector = ({ value, onChange, disabled }) => {
  return (
    <div className="space-y-3">
      <RadioGroup value={value} onValueChange={onChange} disabled={disabled}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Auto Detect */}
          <div
            data-testid="doc-type-auto"
            className={`relative border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ${
              value === 'auto'
                ? 'border-blue-500 bg-blue-50'
                : 'border-slate-200 bg-white hover:border-blue-300 hover:bg-blue-50/50'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => !disabled && onChange('auto')}
          >
            <div className="flex items-start space-x-3">
              <RadioGroupItem value="auto" id="auto" className="mt-1" />
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <Sparkles className="w-5 h-5 text-purple-600" />
                  <Label htmlFor="auto" className="font-semibold text-slate-900 cursor-pointer">
                    Auto Detect
                  </Label>
                </div>
                <p className="text-sm text-slate-600">
                  Automatically identify document type
                </p>
              </div>
            </div>
          </div>

          {/* Bank Statement */}
          <div
            data-testid="doc-type-bank"
            className={`relative border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ${
              value === 'bank_statement'
                ? 'border-blue-500 bg-blue-50'
                : 'border-slate-200 bg-white hover:border-blue-300 hover:bg-blue-50/50'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => !disabled && onChange('bank_statement')}
          >
            <div className="flex items-start space-x-3">
              <RadioGroupItem value="bank_statement" id="bank_statement" className="mt-1" />
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <FileText className="w-5 h-5 text-blue-600" />
                  <Label htmlFor="bank_statement" className="font-semibold text-slate-900 cursor-pointer">
                    Bank Statement
                  </Label>
                </div>
                <p className="text-sm text-slate-600">
                  UK bank transactions and balances
                </p>
              </div>
            </div>
          </div>

          {/* Payslip */}
          <div
            data-testid="doc-type-payslip"
            className={`relative border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ${
              value === 'payslip'
                ? 'border-blue-500 bg-blue-50'
                : 'border-slate-200 bg-white hover:border-blue-300 hover:bg-blue-50/50'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => !disabled && onChange('payslip')}
          >
            <div className="flex items-start space-x-3">
              <RadioGroupItem value="payslip" id="payslip" className="mt-1" />
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <Receipt className="w-5 h-5 text-green-600" />
                  <Label htmlFor="payslip" className="font-semibold text-slate-900 cursor-pointer">
                    Payslip
                  </Label>
                </div>
                <p className="text-sm text-slate-600">
                  UK payroll documents
                </p>
              </div>
            </div>
          </div>
        </div>
      </RadioGroup>
    </div>
  );
};

export default DocumentTypeSelector;
